<template>
<div>
  <!-- <button @click="showAlert">Hello world</button> -->
  <div id="surveyCreatorContainer"></div>
</div> 
</template>

<script>
import * as SurveyCreator from "survey-creator";
import "survey-creator/survey-creator.css";

import * as SurveyKo from "survey-knockout";
import * as widgets from "surveyjs-widgets";
import { init as customWidget } from "@/components/customwidget";
import SurveyService from '@/services/survey.service';

// widgets.icheck(SurveyKo);
widgets.select2(SurveyKo);
widgets.inputmask(SurveyKo);
widgets.jquerybarrating(SurveyKo);
widgets.jqueryuidatepicker(SurveyKo);
widgets.nouislider(SurveyKo);
widgets.select2tagbox(SurveyKo);
widgets.sortablejs(SurveyKo);
widgets.ckeditor(SurveyKo);
widgets.autocomplete(SurveyKo);
widgets.bootstrapslider(SurveyKo);
customWidget(SurveyKo);

SurveyKo.Serializer.addProperty("question", "tag:number");

var CkEditor_ModalEditor = {
  afterRender: function(modalEditor, htmlElement) {
    var editor = window["CKEDITOR"].replace(htmlElement);
    editor.on("change", function() {
      modalEditor.editingValue = editor.getData();
    });
    editor.setData(modalEditor.editingValue);
  },
  destroy: function(modalEditor, htmlElement) {
    var instance = window["CKEDITOR"].instances[htmlElement.id];
    if (instance) {
      instance.removeAllListeners();
      window["CKEDITOR"].remove(instance);
    }
  }
};
SurveyCreator.SurveyPropertyModalEditor.registerCustomWidget(
  "html",
  CkEditor_ModalEditor
);

export default {
  name: "survey-creator",
  props: ['elements', 'id'],
  data() {
    return {
      surveyData: this.elements,
      surveyId: this.id
    };
  }, 
  methods: {
    showAlert() {
        this.$swal({
          icon: 'success',
          title: 'Data berhasil disimpan',
          showConfirmButton: false,
          timer: 1500
        })     
    },
  },
  mounted() {
    let options = { showEmbededSurveyTab: false };
    this.surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainer",
      options
    );

    this.surveyCreator.text = JSON.stringify(this.surveyData);
    let self = this;

    this.surveyCreator.saveSurveyFunc = function() {
      SurveyService.createSurveys(self.id, {elements: JSON.parse(this.text)})
      .then(res => {
         console.log(JSON.stringify(res.data.elements));
         alert("Data berhasil disimpan")
        // this.showAlert();
      }).catch(error => console.error(error));
    };
    this.surveyCreator.showToolbox = "right";
    this.surveyCreator.showPropertyGrid = "right";
    this.surveyCreator.rightContainerActiveItem("toolbox");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
